document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.shipping-protection-toggle');
  const toggle = document.getElementById('ShippingProtectionToggle');
  if (!wrapper || !toggle) return;

  const variantId = wrapper.dataset.variantId;

  // Reflect current cart state on load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      toggle.checked = cart.items.some(item => item.variant_id == variantId);
    });

  toggle.addEventListener('change', function () {
    if (toggle.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(() => location.reload());
    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const line = cart.items.find(item => item.variant_id == variantId);
          if (line) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          }
        })
        .then(() => location.reload());
    }
  });
});